import RoutesUtils from './../../js/RoutesUtils.js';

/**
 * Quién puede abrir **Ajustes › Autorizaciones de condiciones de facturación** (#905). Una sola
 * respuesta, que usan su ruta y el enlace del aviso de OEE › Autorizaciones, para que no contesten
 * cosas distintas.
 *
 * Manda el menú de Mongo, no el rol (`CLAUDE.md` §9 del orquestador): el punto de entrada se dibuja
 * si y solo si la ruta está en el menú efectivo. Los roles solo deciden mientras el menú no está
 * cargado, y son los de la API: ADMIN y DIRECTOR, como el mapa de aprobación de vacaciones.
 */
export const ROLES_AJUSTES_AUTORIZACIONES = ['ADMIN', 'DIRECTOR'];

export const RUTA_AJUSTES_AUTORIZACIONES = '/autorizacionescondiciones/';

export function puedeAbrirAjustesAutorizaciones() {
    return RoutesUtils.tieneAcceso(RUTA_AJUSTES_AUTORIZACIONES, ROLES_AJUSTES_AUTORIZACIONES);
}

export default {
    ROLES_AJUSTES_AUTORIZACIONES,
    RUTA_AJUSTES_AUTORIZACIONES,
    puedeAbrirAjustesAutorizaciones
};
